/*
  Engraving: adds an engraved product (text as an `Engraving` property) plus the
  fee product. All fees share one fee line whose qty tracks total engraved items.

  Product page: when the engraving box is ticked, this takes over the add-to-cart
  click (main.js only collects Simple Bundles selects, so it would drop the text).
  Untouched products and unticked boxes fall through to main.js as normal.

  Cart: engraved rows use their own data-action names (see cart-line-item.liquid),
  which main.js ignores, so +/-/remove here move the product line and the shared
  fee line by the same amount in one request.
*/
(function () {
  var ALLOWED = /^[A-Za-z0-9 .,'&!?#\-]+$/;

  function sectionId() {
    return window.location.pathname === '/cart' ? 'main_cart_items' : 'cart';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json();
    });
  }

  // Mirrors main.js: swap in the fresh drawer, then sync the header counters.
  function renderCart(data) {
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }
    var html = data.sections && data.sections[sectionId()];
    var container = document.querySelector('[data-cart-update-container]');
    if (html && container) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      container.innerHTML = doc.querySelector('[data-cart-update-container]').innerHTML;
    }
    var count = document.querySelector('[data-cart-current-count]');
    if (count) {
      document.querySelectorAll('[data-cart-items-counter]').forEach(function (el) {
        el.setAttribute('data-cart-items-counter', count.getAttribute('data-cart-current-count'));
        el.innerHTML = count.getAttribute('data-cart-current-count');
      });
    }
  }

  function openCart() {
    var cart = document.querySelector('.cart');
    if (cart) cart.classList.add('cart-visible');
    document.documentElement.classList.add('cart-visible');
    document.body.style.overflow = 'hidden';
  }

  // --- Product page -------------------------------------------------------

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-engraving-toggle]')) return;
    var field = e.target.closest('[data-engraving]');
    field.querySelector('[data-engraving-body]').hidden = !e.target.checked;
    field.querySelector('[data-engraving-error]').textContent = '';
    if (e.target.checked) field.querySelector('[data-engraving-input]').focus();
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-engraving-input]')) return;
    var field = e.target.closest('[data-engraving]');
    field.querySelector('[data-engraving-count]').textContent = e.target.value.length;
    field.querySelector('[data-engraving-error]').textContent = '';
  });

  // Capture phase so this runs before main.js's body-level click handler.
  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('[data-action="add-to-cart"]');
      if (!button) return;
      var form = button.closest('form');
      var field = form && form.querySelector('[data-engraving]');
      if (!field || !field.querySelector('[data-engraving-toggle]').checked) return;

      e.preventDefault();
      e.stopPropagation();

      var input = field.querySelector('[data-engraving-input]');
      var error = field.querySelector('[data-engraving-error]');
      var text = input.value.trim();
      if (!text) {
        error.textContent = 'Enter your engraving';
        input.focus();
        return;
      }
      if (!ALLOWED.test(text)) {
        error.textContent = 'Letters, numbers and basic punctuation only';
        input.focus();
        return;
      }

      var variantId = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[name="quantity"]');
      var quantity = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      // Text sits on the product line. The fee line has no properties, so every
      // engraving merges into one shared fee line (qty = total engraved items).
      var properties = { Engraving: text };
      document
        .querySelectorAll('#simple-bundles-io-options select[name*="properties"]')
        .forEach(function (select) {
          var key = select.name.match(/\[(.*?)\]/);
          if (key && select.value) properties[key[1]] = select.value;
        });

      var items = [
        { id: variantId, quantity: quantity, properties: properties },
        { id: field.getAttribute('data-fee-variant-id'), quantity: quantity },
      ];

      var label = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span>Adding to cart</span>';

      post('/cart/add.js', { items: items, sections: sectionId() })
        .then(function (data) {
          if (data.status) {
            // 422 etc: e.g. inventory limited.
            error.textContent = data.description || data.message || 'Could not add to cart';
            return;
          }
          renderCart(data);
          openCart();
        })
        .catch(function (err) {
          console.error('Engraving add to cart:', err);
          error.textContent = 'Could not add to cart';
        })
        .finally(function () {
          button.disabled = false;
          button.innerHTML = label;
        });
    },
    true
  );

  // --- Cart ---------------------------------------------------------------

  document.body.addEventListener('click', function (e) {
    var button = e.target.closest(
      '[data-action="update-engraved-quantity"], [data-action="remove-engraved"]'
    );
    if (!button) return;
    e.preventDefault();

    var current = parseInt(button.getAttribute('data-quantity'), 10) || 0;
    var quantity = 0;
    if (button.getAttribute('data-action') === 'update-engraved-quantity') {
      quantity = button.getAttribute('name') === 'plus' ? current + 1 : current - 1;
    }

    // The shared fee line moves by the same amount as this engraved line.
    var feeQuantity = parseInt(button.getAttribute('data-fee-quantity'), 10) || 0;
    var updates = {};
    updates[button.getAttribute('data-line-item-key')] = quantity;
    updates[button.getAttribute('data-fee-key')] = Math.max(0, feeQuantity + quantity - current);

    var lockup = document.querySelector('.cart__form-lockup');
    if (lockup) lockup.classList.add('working');
    button.disabled = true;

    post('/cart/update.js', { updates: updates, sections: sectionId() })
      .then(function (data) {
        if (data.status) {
          console.error('Engraving cart update:', data.description || data.message);
          return;
        }
        renderCart(data);
      })
      .catch(function (err) {
        console.error('Engraving cart update:', err);
      })
      .finally(function () {
        button.disabled = false;
        if (lockup) lockup.classList.remove('working');
      });
  });
})();
